import {env} from '../config/env.js';

let amplifyConfigured = false;

export async function ensureAmplify(): Promise<void> {
    if (amplifyConfigured) return;
    if (typeof window === 'undefined') return;
    const {Amplify} = await import('aws-amplify');
    Amplify.configure({
        Auth: {
            Cognito: {
                userPoolId: env.COGNITO_USER_POOL_ID,
                userPoolClientId: env.COGNITO_APP_CLIENT_ID,
            },
        },
    });
    amplifyConfigured = true;
}
